import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import ReactTooltip from 'react-tooltip';
import SingleInputForm from 'components/common/SingleInputForm';

import iconEdit from 'assets/images/icons/icon-pencil.svg';

import cn from 'classnames';
import styles from './styles.scss';
import noBuildings from 'assets/images/no_photo/no_buildings_90px.png';
import noPhoto from 'assets/images/no_photo/no_photo_small.png';
import { connect } from 'react-redux';
import { dupCollection, deleteCollection, renameCollection } from 'actions/collections';

import Modal from 'components/Modal';
import { ROOT_URL } from '../../constants/Config';
import tracker from '../../services/tracker';
import { withTranslation } from 'react-i18next';

class Collections extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleDupClick= () => {
    tracker.sendEvent('Web_Selections_Duplicate');
    this.props.dupCollection({
      referal: this.props.referal,
      userUid: this.props.userUid
    });
  }

  handleDeleteClick = () => {
    tracker.sendEvent('Web_Selections_Delete');
    this.props.deleteCollection({
      referal: this.props.referal,
      userUid: this.props.userUid
    });
  }

  handleRename = (name) => {
    this.props.renameCollection({
      referal: this.props.referal,
      userUid: this.props.userUid,
      name
    });
  }

  renderNoPhotos() {
    const { total = 0 } = this.props;

    if (!total) {
      return <img src={noBuildings} alt="" />;
    }

    return Array(total).fill(undefined).map((value, index) => (
      <span className={styles.ItemImage} style={{ background: '#fff' }} key={index}>
        <img className={styles.ItemImageNoPhoto} src={noPhoto} alt="" />
      </span>
    )).slice(0, 4);
  }

  render() {
    const { name, referal, total = 0, photos, t } = this.props;

    const hasPhotos = photos && photos.length;
    return (
      <div className={styles.ListItem} key={referal} onClick={() => ReactTooltip.hide(this.pancelEditEl)}>
        <Link to={`/collection/manage/${referal}`} className={styles.ItemPhotos}>
          {
            hasPhotos ? photos.slice(0, 4).map(
              ({ id }) => (
                <span className={styles.ItemImage} key={id}>
                  <img src={`${ROOT_URL}/image?id=${id}&size=small`} alt="" />
                </span>
              )
            ) : this.renderNoPhotos()
          }
          {/* <span className={styles.ItemTopHover}> */}
          {/* <Link to={`/collection/manage/${referal}`} className={styles.HoverText}> */}
          {/* Перейти&nbsp;к&nbsp;подборке */}
          {/* </Link> */}
          {/* </span> */}
        </Link>
        <Link to={`/collection/manage/${referal}`} className={styles.MainLink}></Link>
        <span className={styles.ItemMain}>
          <SingleInputForm
            className={styles.ItemName}
            value={name}
            onSubmit={this.handleRename}
            linkTo={`/collection/manage/${referal}`}
          >
            <span
              className={styles.NameEdit}
              data-tip={t('components.collectionsItem.rename')}
              data-for="global"
              ref={pancelEditEl => { this.pancelEditEl = pancelEditEl; }}
              onMouseEnter={() => ReactTooltip.show(this.pancelEditEl)}
              onMouseLeave={() => ReactTooltip.hide(this.pancelEditEl)}
              onClick={() => {
                ReactTooltip.hide(this.pancelEditEl);
                tracker.sendEvent('Web_Selections_Edit');
              }}
            >
              <img alt="icon" src={iconEdit} />
            </span>
          </SingleInputForm>
          <span className={styles.ItemDescrip}>
            {t('components.collectionsItem.description', { total })}
          </span>
        </span>

        <div className={styles.ItemHover}>
          <span
            className={cn(styles.HoverIcon, styles.HoverIconDuplicate)}
            onClick={() => this.handleDupClick(referal)}
          >
            {t('components.collectionsItem.dup')}
          </span>
          <span
            className={cn(styles.HoverIcon, styles.HoverIconDelete)}
            onClick={() => this.setState({ showModal: true })}
          >
            {t('components.collectionsItem.del')}
          </span>
        </div>

        <Modal
          title={t('components.collectionsItem.deleteCollection')}
          isOpen={this.state.showModal}
          handleClose={() => this.setState({ showModal: false })}
          contentStyle={{
            minWidth: '736px',
            minHeight: '120px'
          }}
        >
          <div className={styles.Dialog}>
            {t('components.collectionsItem.sure', { name })}
            <div className={styles.Buttons}>
              <div
                className={cn(styles.DeleteButton, 'button-primary', 'button-primary--md')}
                onClick={() => this.handleDeleteClick(referal)}
              >
                {t('components.collectionsItem.del')}
              </div>
              <div
                className={styles.ButtonCancel}
                onClick={() => this.setState({ showModal: false })}
              >
                {t('components.collectionsItem.cancel')}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default connect(
  state => ({
    userUid: state.profile.hash,
    collections: state.collections.data
  }),
  { dupCollection, deleteCollection, renameCollection }
)(withTranslation()(Collections));



// WEBPACK FOOTER //
// ./src/components/CollectionsItem/CollectionsItem.js